import Reveal from "@/components/Reveal";

const IMG = {
  one: "https://static.prod-images.emergentagent.com/jobs/2a594c21-650d-45e7-b5a4-d643f77ca0a9/images/135603cb7752fe1571dcd9e63941930dde4350ae1d5dc3213ed9e4db2455aae0.png",
  two: "https://static.prod-images.emergentagent.com/jobs/2a594c21-650d-45e7-b5a4-d643f77ca0a9/images/3673584cec1bc56feb8b562d53d64fdaf5d9da74f308177a76256d2f80233f96.png",
  three: "https://static.prod-images.emergentagent.com/jobs/2a594c21-650d-45e7-b5a4-d643f77ca0a9/images/de64f46d9fc28ad4cd6ca7004674245ad751182352e5da42045494cce5516f45.png",
};

const CARDS = [
  {
    tag: "Hostel hellos",
    title: "Hostels are so fun but…",
    body: "It is pretty hard to make plans with people. You meet someone over breakfast, swap Instagrams, and never see them again. Lots of fleeting hellos.",
    img: IMG.one,
    bg: "bg-[#FFEDE6]",
    accent: "bg-[#FF5A36]",
  },
  {
    tag: "Better together",
    title: "Some experiences are better with people.",
    body: "You could see the same places alone. But the core memories — the ones you recall after a trip — almost always come with people.",
    img: IMG.two,
    bg: "bg-[#FFF4D6]",
    accent: "bg-[#FFC857]",
  },
  {
    tag: "Small groups",
    title: "Small intentional groups.",
    body: "Groups are kept small at 4–5, so it feels comfortable and the vibe stays easy. Having a few go-to people just elevates the whole experience.",
    img: IMG.three,
    bg: "bg-[#EAF0E6]",
    accent: "bg-[#5B7C4F]",
  },
];

export default function WhyCompass() {
  return (
    <section
      data-testid="why-compass-section"
      className="bg-[#FDFBF7]"
    >
      <div className="max-w-md mx-auto md:max-w-6xl px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#1A1A1A]">
            Why Fourdays
          </h2>
        </Reveal>

        <div className="mt-10 md:mt-14 space-y-6 md:space-y-0 md:grid md:grid-cols-3 md:gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={100 + i * 100}>
              <article
                data-testid={`why-card-${i + 1}`}
                className={`${c.bg} rounded-[24px] overflow-hidden border border-[#E5E0D8]/70 group`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="w-full aspect-[4/3] md:aspect-[5/6] object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span
                    className={`absolute top-3 left-3 text-[11px] uppercase tracking-widest font-semibold ${c.accent} text-white px-3 py-1.5 rounded-full`}
                  >
                    {c.tag}
                  </span>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="font-display font-extrabold text-2xl md:text-[26px] leading-tight tracking-tight text-[#1A1A1A]">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-[#5C5C5C] text-[15px] md:text-base leading-relaxed">
                    {c.body}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
